import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { TenantContext, updateTenantContext } from "@eres/ejari-core/contexts/TenantContext";
import Strings from "@my-dld/assets/strings";
import { EjariProperty } from "@eres/ejari-api/Entity";
import { I8N, LocaleUtil } from "@eres/core";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { navigate } from "@my-dld/utils/StoreUtils";
import PageContent from "@my-dld/components/PageContent";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import PageTitle from "@my-dld/components/PageTitle";

interface Props extends RoutedViewProps {

}

interface State {
	properties: EjariProperty[];
}

class PropertyList extends Component<Props, State> {
	static contextType = TenantContext;
	context!: React.ContextType<typeof TenantContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			properties: [],
		};
	}

	private static renderRow( property: EjariProperty, index: number ) {
		const unitNo = !isEmptyStringOrNull( property.UnitNo ) ? property.UnitNo : "";
		return (
			<tr key={ `property_list_${ index }_${ unitNo }` }>
				<td data-label={ Strings.property_number }>{ unitNo }</td>
				<td data-label={ Strings.area }>{ I8N.isRTL() ? property.AreaAr : property.AreaEn }</td>
				<td data-label={ Strings.building_name }>{ I8N.isRTL() ? property.BuildingNameAr : property.BuildingNameEn }</td>
				<td data-label={ Strings.property_status.replace( "<br/>", "" ) }>{ property.IsRented ? Strings.rented : Strings.vacant }</td>
				<td>
					<a href="#" data-item={ JSON.stringify( property ) }>
						<i className="far fa-arrow-alt-circle-right"/>
					</a>
				</td>
			</tr>
		);
	}

	componentDidMount() {
		const properties = this.context.properties;
		if ( properties ) {
			this.setState( {
				properties: ( properties && properties.length > 0 ) ? properties : [],
			}, this.configDataTable );
		}
	}

	configDataTable = () => {
		try {
			window.$( "#PropertyList" ).DataTable( {
				//language: LocaleUtil.Select( DataTableLang ),
                language: { url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/" + (I8N.current == "ar" ? "Arabic.json" : "English.json"), lengthMenu: '_MENU_' },
                dom: "<'table-responsive'rt>" + "<'dt-cfooter'i<'dt-fpl'pl>>",
                pagingType: "simple_numbers",
				responsive: false,
				lengthChange: false,
				scrollX: true
			} );
			const onPropertySelect = this.onPropertySelect;
			window.$( "#PropertyList" ).on( "click", "a", function () {
				// @ts-ignore
				let item = JSON.parse( this.getAttribute( "data-item" ) );
				if ( item )
					onPropertySelect( item );
				return false;
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};

	render() {
		const { properties } = this.state;
		return <PageContent title={ Strings.register_certificate }>
			<PageTitle title={ Strings.register_certificate } paths={ [ DashboardBCItem ] }/>
			<div className="row">
				<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
					<div className="table-box mb-3">
						<div className="table-title">{ Strings.properties }</div>
						<table
							id="PropertyList"
							className="table table-borderless table-condensed table-striped table-responsive-sm dataTable no-footer">
							<thead>
							<tr>
								<th>{ Strings.property_number }</th>
								<th>{ Strings.area }</th>
								<th>{ Strings.building_name }</th>
								<th>{ Strings.property_status.replace( "<br/>", "" ) }</th>
								<th>{ " " }</th>
							</tr>
							</thead>
							<tbody>
							{ properties.map( ( project: EjariProperty, index: number ) => {
								return PropertyList.renderRow( project, index );
							} ) }
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</PageContent>;
	}

	private onPropertySelect = ( property: EjariProperty ) => {
		updateTenantContext( { property: property } );
		navigate( "details" );
	};
}

export default PropertyList;
